// Centralised contact configuration for Velora Web Agency
export const CONTACT = {
  brand: "Velora",
  phone: "9684098287",
  whatsapp: "919684098287", // country code + number for wa.me
  email: "velorawebs08@gmail.com",
  founderEmail: "stavanbhore77@gmail.com",
  instagramHandle: "sttavannn.7708",
  instagramUrl: "https://www.instagram.com/sttavannn.7708/",
};

const MSG_WHATSAPP =
  "Hi Velora, I want a website from you. Can we discuss the project?";
const MSG_INSTAGRAM =
  "Hi Velora, I want a website from you. Let's connect!";
const MSG_EMAIL_SUBJECT =
  "Website Development Inquiry – Velora Agency";
const MSG_EMAIL_BODY =
  "Hi Velora,\n\nI am interested in getting a website developed. Can we discuss the details?\n\nLooking forward to your response.";

export const whatsappLink = () =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(MSG_WHATSAPP)}`;

// Instagram does not support pre-filled DM via URL. Open DM thread directly.
export const instagramLink = () =>
  `https://ig.me/m/${CONTACT.instagramHandle}`;

export const instagramProfile = () => CONTACT.instagramUrl;

// Opens Gmail compose in a new tab with pre-filled fields
export const gmailLink = () =>
  `https://mail.google.com/mail/?view=cm&fs=1&to=${CONTACT.email}&su=${encodeURIComponent(
    MSG_EMAIL_SUBJECT,
  )}&body=${encodeURIComponent(MSG_EMAIL_BODY)}`;

export const mailtoLink = () =>
  `mailto:${CONTACT.email}?subject=${encodeURIComponent(MSG_EMAIL_SUBJECT)}&body=${encodeURIComponent(MSG_EMAIL_BODY)}`;

export const telLink = () => `tel:+91${CONTACT.phone}`;

export const MESSAGES = {
  whatsapp: MSG_WHATSAPP,
  instagram: MSG_INSTAGRAM,
  emailSubject: MSG_EMAIL_SUBJECT,
  emailBody: MSG_EMAIL_BODY,
};
